import { useQuery } from '@tanstack/react-query';
import { contractApi } from '@/features/contracts/api/contractApi';

/**
 * Hook pour récupérer le PDF d'un contrat sous forme de Blob
 * Le Blob est mis en cache par React Query
 */
export const useContractPdfBlob = (contractId: number | undefined, enabled = true) => {
  return useQuery({
    queryKey: ['contract-pdf', contractId],
    queryFn: async () => {
      if (!contractId) throw new Error('Contract ID requis');
      return contractApi.getDocumentBlob(contractId);
    },
    enabled: enabled && !!contractId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
